import { useEffect, useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Headlines from './components/Headlines';
import HotList from './components/HotList';
import MemeSection from './components/MemeSection';
import SceneSection from './components/SceneSection';
import FaqSection from './components/FaqSection';
import About from './components/About';
import Footer from './components/Footer';

function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-primary-500 text-lg text-background-50 shadow-lg transition-all hover:bg-primary-600 ${
        show ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-4 opacity-0'
      }`}
    >
      <i className="ri-arrow-up-line"></i>
    </button>
  );
}

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <Headlines />
        <HotList />
        <MemeSection />
        <SceneSection />
        <FaqSection />
        <About />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}